/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationPartnerConnection
 */
export interface OrganizationPartnerConnection {
    /**
     * Partner's id (matching the stingray.organization_partner table)
     * @type {string}
     * @memberof OrganizationPartnerConnection
     */
    partnerId: string;
}

export function OrganizationPartnerConnectionFromJSON(json: any): OrganizationPartnerConnection {
    return OrganizationPartnerConnectionFromJSONTyped(json, false);
}

export function OrganizationPartnerConnectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationPartnerConnection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partnerId': json['partnerId'],
    };
}

export function OrganizationPartnerConnectionToJSON(value?: OrganizationPartnerConnection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'partnerId': value.partnerId,
    };
}

